import React from "react";

import CustomCarousel from "./CustomCarousel";
import { useModel, useModelUpdate } from "./hooks/ModelProvider";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";
import imgUrls from "../data/carouselUrls.json";
import { visuallyHidden } from "@mui/utils";

export default function Color({children}) {
 
  const setModel = useModelUpdate();
  const model = useModel();

  function onRadioButtonChange(e){
    setModel({color: e.target.value});
  }
  const indexFunc = (e) =>
    e.color === model.color &&
    e.model === model.model &&
    e.nextGen === model.nextGen;
  const onColorClick = (e, color) => {
    setModel({ color: color });
  };

  return (
    <>
   
   
      <Stack direction={{xs:'column', sm:"row"}} sx={{ paddingLeft: 0, marginBottom: "30px"}}>
     
      <Stack>
        {children}
        <h3 style={{ paddingTop: "20px", width: 'fit-content' }}>Elige el color de tu unidad</h3>
        <Stack direction="row">
        <div className="color-select-container">
          <div className={model.color === 'rojo' ? "color-select-ring active": "color-select-ring"}></div>
          <div className='color-select-inner-ring'></div>
          <img className="color-select-circle"
            onTouchEnd={(e) => {
              onColorClick(e, "rojo");
            }}
            onClick={(e) => {
              onColorClick(e, "rojo");
            }}
            src="https://kwjalisco.com/wp-content/uploads/2022/09/rojo.png"
            alt=""
          />
          <img
      
            className="color-select"
            src="https://kwjalisco.com/wp-content/uploads/2022/09/rojo.png"
            alt=""
          />
        </div>
        <div className="color-select-container">
          <div className={model.color === 'blanco' ? "color-select-ring active": "color-select-ring"}></div>
           <div className='color-select-inner-ring'></div>
          <img className="color-select-circle"
            onTouchEnd={(e) => {
              onColorClick(e, "blanco");
            }}
            onClick={(e) => {
              onColorClick(e, "blanco");
            }}
            src="https://kwjalisco.com/wp-content/uploads/2022/09/blanco.png"
            alt=""
          />
          <img

            className="color-select"
            src="https://kwjalisco.com/wp-content/uploads/2022/09/blanco.png"
            alt=""
          />
        </div>
        <div className="color-select-container">
          <div className={model.color === 'gris' ? "color-select-ring active": "color-select-ring"}></div>
           <div className='color-select-inner-ring'></div>
          <img className="color-select-circle"
            onTouchEnd={(e) => {
              onColorClick(e, "gris");
            }}
            onClick={(e) => {
              onColorClick(e, "gris");
            }}
            src="https://kwjalisco.com/wp-content/uploads/2022/09/plata.png"
            alt=""
          />
          <img
       
            className="color-select"
            src="https://kwjalisco.com/wp-content/uploads/2022/09/plata.png"
            alt=""
          />
        </div>
        <div className="color-select-container">
          <div className={model.color === 'azul' ? "color-select-ring active": "color-select-ring"}></div>
           <div className='color-select-inner-ring'></div>
          <img className="color-select-circle"
            onTouchEnd={(e) => {
              onColorClick(e, "azul");
            }}
            onClick={(e) => {
              onColorClick(e, "azul");
            }}
            src="https://kwjalisco.com/wp-content/uploads/2022/09/azul.png"
            alt=""
          />
          <img
            
            className="color-select"
            src="https://kwjalisco.com/wp-content/uploads/2022/09/azul.png"
            alt=""
          />
        </div>
        </Stack>
        </Stack>
        <CustomCarousel
          className='unit-color-carousel'
          state={model}
          indexFunc={indexFunc}
          imgUrls={imgUrls}
        />
      </Stack>
            
      <FormControl>
        <FormLabel 
        sx={visuallyHidden}
         id="demo-radio-buttons-group-label">
          Color Selección
        </FormLabel>
        <RadioGroup
          sx={visuallyHidden}
          aria-labelledby="demo-radio-buttons-group-label"
         value={model.color}
         onChange={onRadioButtonChange}
          name="radio-buttons-group"
        >
          <FormControlLabel
            labelPlacement="start"
            control={
              <Radio
                className="visually-hidden configurador-form"
                inputProps={{ title: "color-de-unidad" }}
                name="color-de-unidad"
                value="rojo"
              />
            }
            label=""
          />
          <FormControlLabel
            labelPlacement="start"
            control={
              <Radio
                className="visually-hidden configurador-form"
                inputProps={{ title: "color-de-unidad," }}
                name="color-de-unidad"
                value="blanco"
              />
            }
            label=""
          />
          <FormControlLabel
            labelPlacement="start"
            control={
              <Radio
                className="visually-hidden configurador-form"
                inputProps={{ title: "color-de-unidad" }}
                name="color-de-unidad"
                value="plata"
              />
            }
            label=""
          />
          <FormControlLabel
            labelPlacement="start"
            control={
              <Radio
                className="visually-hidden configurador-form"
                inputProps={{ title: "color-de-unidad" }}
                name="color-de-unidad"
                value="azul"
              />
            }
            label=""
          />
        </RadioGroup>
     
      </FormControl>
    </>
  );
}
